import React from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ModernButton } from '../../ui/modern';

function SortableItem({ field, isSelected, onSelect, onRemove }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: field.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex items-center justify-between gap-3 border rounded-xl px-3 py-2 cursor-pointer ${
        isSelected
          ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
          : 'border-gray-200 dark:border-white/10 bg-white dark:bg-white/5'
      }`}
      onClick={() => onSelect(field)}
    >
      <div className="flex items-center gap-3">
        <button
          type="button"
          className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          {...attributes}
          {...listeners}
        >
          ⠿
        </button>
        <div>
          <div className="font-medium text-gray-900 dark:text-white">{field.label || 'Untitled Field'}</div>
          <div className="text-xs text-gray-500 dark:text-slate-400">{field.fieldType} • {field.fieldKey || 'fieldKey'}</div>
        </div>
      </div>
      <ModernButton variant="danger" size="sm" onClick={(e) => { e.stopPropagation(); onRemove(field); }}>
        Remove
      </ModernButton>
    </div>
  );
}

export default function FormPreview({ fields, selectedFieldId, onSelectField, onRemoveField, onReorder }) {
  return (
    <div className="space-y-3">
      <div className="text-sm font-semibold text-gray-700 dark:text-slate-300">Form Preview</div>
      <DndContext collisionDetection={closestCenter} onDragEnd={onReorder}>
        <SortableContext items={fields.map((f) => f.id)} strategy={verticalListSortingStrategy}>
          <div className="space-y-2">
            {fields.map((field) => (
              <SortableItem
                key={field.id}
                field={field}
                isSelected={selectedFieldId === field.id}
                onSelect={onSelectField}
                onRemove={onRemoveField}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
      {fields.length === 0 && (
        <div className="text-sm text-gray-500 dark:text-slate-400">No fields yet. Add fields from the palette.</div>
      )}
    </div>
  );
}


